import axios from "axios";

// export const baseURL = "http://localhost:5000/onedohaapp/us-central1/app";
export const baseURL = "https://us-central1-onedohaapp.cloudfunctions.net/app";

const api = axios.create({
    baseURL,
});

api.interceptors.request.use((config) => {
    // Retrieve the token from where you stored it (e.g., local storage)
    const userToken = localStorage.getItem("userToken");
    if (userToken) {
        config.headers.Authorization = `Bearer ${userToken}`;
    }
    return config;
});

// PROBLEMS NEED TO BE FIXED IN BACKEND (1)
const handleRequestError = (error) => {
    console.error("API request error:", error);
    return { success: false, message: error.message };
};

export const validateUserJWTToken = async (token) => {
    try {
        const res = await api.get(`/api/users/jwtVerification`, {
            headers: { Authorization: "Bearer " + token }
        })
        return res.data.data;
    } catch (error) {
        return handleRequestError(error);

    }
}

export const confirmPaymentThanhToan = async (product, user) => {
    try {
        const res = await api.post(`/api/products/paymentThanhToan`, {
            product: product,
            user: user
        });
        return res.data.data;
    } catch (error) {
        return null
    }
}

export const addingPhoneNumberToUser = async (user_id, phoneNumber) => {
    try {
        const res = await api.post(`/api/users/UpdatePhoneNumber/${user_id}`, {
            phoneNumber: phoneNumber
        });
        return res.data.data;
    } catch (error) {
        return handleRequestError(error);
    }
};


// add new product

export const addNewProduct = async (data) => {
    try {
        const res = await api.post(`/api/products/create`, {
            ...data
        });
        return res.data.data;
    } catch (error) {
        return null
    }
}

export const updateSelectedProduct = async (data) => {
    try {
        const res = await api.post(`/api/products/update`, {
            ...data
        });
        return res.data.data;
    } catch (error) {
        return null
    }
}

export const getCurrentUser = async (uid) => {
    try {
        const res = await api.get(`/api/users/currentUser?uid=${uid}`);
        return res.data.data;
    } catch (error) {
        return handleRequestError(error);

    }
}

export const getAllProducts = async () => {
    try {
        const res = await api.get(`/api/products/all`);
        return res.data.data;
    } catch (error) {
        console.error("Error fetching products:", error.message);
        return handleRequestError(error);

    }
}

export const deleteItem = async (productId) => {
    try {
        const res = await api.delete(`/api/products/delete/${productId}`);
        return res.data.data;
    } catch (error) {
        return handleRequestError(error);

    }
}

export const getAllUsers = async () => {
    try {
        const res = await api.get(`/api/users/all`);
        return res.data.data;
    } catch (error) {
        console.error("Error fetching users:", error.message);
        return handleRequestError(error);

    }
}

export const addNewItemToCart = async (user_id, data) => {
    try {
        const res = await api.post(
            `/api/products/addToCart/${user_id}`,
            { ...data }
        );
        return res.data.data;
    } catch (error) {
        return handleRequestError(error);

    }
}

export const updateCartItemQuantity = async (user_id, product_id, new_quantity) => {
    try {
        const res = await api.post(
            `/api/products/updateCartItemQuantity/${user_id}/${product_id}`,
            { new_quantity }
        );
        return res.data;
    } catch (error) {
        return handleRequestError(error);

    }
};

export const updateAllCartItemQuantitiesToZero = async (user_id) => {
    try {
        const res = await api.post(
            `/api/products/updateAllCartItemQuantitiesToZero/${user_id}`
        );
        return res.data.data;
    } catch (error) {
        return handleRequestError(error);

    }
};


export const getAllCartItems = async (user_id) => {
    try {
        const res = await api.get(
            `/api/products/getCartItems/${user_id}`
        );
        return res.data.data;
    } catch (error) {
        return handleRequestError(error);

    }
}

export const getAllOrders = async (user) => {
    try {
        const res = await api.get(`/api/products/orders`, {
            params: user, // Pass user as a query parameter
        });
        return res.data;
    } catch (error) {
        console.error("Error fetching orders:", error.message);
        return handleRequestError(error);

    }
}

export const getAllCategories = async () => {
    try {
        const res = await api.get(`/api/products/productCategory`)
        return res.data;
    } catch (error) {
        console.error("Error fetching orders:", error.message);
        return handleRequestError(error);

    }
}


export const createOrder = async (orderData) => {
    try {
        const res = await api.post(`/api/products/createOrder`, orderData);
        return res.data;
    } catch (error) {
        return handleRequestError(error);

    }
}

export const createOrderFromStaff = async (orderData) => {
    try {
        const res = await api.post(`/api/products/createOrderFromStaff`, orderData);
        return res.data;
    } catch (error) {
        return handleRequestError(error);
    }
}

// staff 

export const getCartFromStaff = async (userId, orderNumber) => {
    try {
        const res = await api.get(
            `/api/products/StaffCart/${userId}?orderNumber=${orderNumber}`
        );
        return res.data;
    } catch (error) {
        return handleRequestError(error);
    }
}

export const addNewItemToCartStaff = async (user_id, data, orderNumber) => {
    try {
        const res = await api.post(
            `/api/products/StaffaddToCart/${user_id}?orderNumber=${orderNumber}`,
            { ...data }
        );
        return res.data.data;
    } catch (error) {
        return handleRequestError(error);

    }
}

export const updateCartItemQuantityStaff = async (user_id, product_id, new_quantity, orderNumber) => {
    try {
        const res = await api.post(
            `/api/products/updateCartItemQuantityStaff/${user_id}/${product_id}?orderNumber=${orderNumber}`,
            { new_quantity }
        );
        return res.data;
    } catch (error) {
        return handleRequestError(error);

    }
};

export const updateAllCartItemQuantitiesToZeroStaff = async (user_id, orderNumber) => {
    try {
        const res = await api.post(
            `/api/products/updateAllCartItemQuantitiesToZeroStaff/${user_id}?orderNumber=${orderNumber}`
        );
        return res.data.data;
    } catch (error) {
        return handleRequestError(error);

    }
};

export const getAllCartFromStaff = async (user_id) => {
    try {
        const res = await api.get(
            `/api/products/getAllCartStaff/${user_id}`
        );
        return res.data;
    } catch (error) {
        return handleRequestError(error);
    }
}


// Function to create or update a cart with a "dummy" field
export const createMoreCart = async (userId, currentCart) => {
    try {
        const response = await api.post(
            `/api/products/createMoreCart/${userId}?currentCart=${currentCart}`
        );
        return response.data;
    } catch (error) {
        // Handle any errors here
        console.error('Error:', error);
        throw error; // Rethrow the error to handle it at the higher level
    }
};
